import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h1>inventory</h1>
        </div>
    );
};

export default Inventory;